import { loadable } from 'react-lazily/loadable';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { TransactionFunctions, UserFunctions } from '../redux/actions/AppActionFunctions/AppActions';
const GatewayAssignmentView = loadable(() => import('../components/Gateway/View/GatewayAssignmentView')).default;
const debug = process.env.REACT_APP_DEBUG && false;
const mapStateToProps = (state, ownProps) => {
    debug && console.log('GatewayAssignment own props', ownProps);
    return {
        user: state.AppReducer?.user,
        contextCustomer: state.AppReducer.contextCustomer,
        userCustomers: state.AppReducer.userCustomers,
    };
};
const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        init: (cognitoUser, userGroupRoles) => {
            debug && console.log('GatewayAssignment Container requested init', ownProps);
        },
        userFunctions: bindActionCreators(UserFunctions, dispatch),
        transactionFunctions: bindActionCreators(TransactionFunctions, dispatch),
    };
};
/** @deprecated - No longer used */
export default connect(mapStateToProps, mapDispatchToProps)(GatewayAssignmentView);
